// @flow

import React, { type Node } from 'react';
import {
  Body,
  Content,
} from '../../../organisms/shared-styled-components';
import styled from 'styled-components';
import { MerchantLogo } from '../../../organisms/merchant-info';
import { MobileTotalAmount } from '../../../organisms/mobile-total-amount';
import {
  usePendingIncomingPayment,
} from '@tectonics/prs/incoming-payment';

import { formatValueWithMask } from '@tectonics/components/input-mask/format-value-with-mask';

import { RenderTotalAndDueDate } from './opay-page-components';
import { NIGERIA_MASK } from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/customer-form/nigerian/field-nigerian-phone-number';

export function OpayPage(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const phoneNumber: string = incomingPayment.phone_number ?? '';
  const phoneNumberFormatted = phoneNumber === '' ? '' :formatValueWithMask(phoneNumber, NIGERIA_MASK);
  return (
    <>
      <Content>
        <MerchantLogo height="100px" />
        <MobileTotalAmount />
        <Body>
          <Title>
            Your Payment Request has been generated successfully.
          </Title>
          <RenderTotalAndDueDate />
          <Text id="paymentInstructions">
            Instructions to how to proceed with your payment will be sent to you by email
            <strong>{incomingPayment.email}</strong> or phone <strong>{phoneNumberFormatted}</strong>.
          </Text>
        </Body>
      </Content>

    </>
  );
}

const Title = styled.div`
  padding: 32px 16px;
  font-size: 1.8em;
  font-family: ${props => props.theme.fontFamily.display};
`;
const Text = styled.div`
  padding: 32px 16px;
  font-size: 1.1em;
  font-family: ${props => props.theme.fontFamily.display};
  border-top: 1px solid #eeeeee;
`;
